export const EVALUATE_FORMULA = 'EVALUATE_FORMULA';
export const CREATE_FORMULA = 'CREATE_FORMULA';
export const DELETE_FORMULA = 'DELETE_FORMULA';
export const UPDATE_FORMULA = 'UPDATE_FORMULA';
export const FORMULA_REQUEST = 'FORMULA_REQUEST';
export const FORMULA_SUCCESS = 'FORMULA_SUCCESS';
